import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=263f91b2&scoped=true"
import script from "./addPage.vue?vue&type=script&lang=js"
export * from "./addPage.vue?vue&type=script&lang=js"
import style0 from "./addPage.vue?vue&type=style&index=0&id=263f91b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f91b2",
  null
  
)

export default component.exports